import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { TransformationSection } from '../components/sections/TransformationSection';
import { BlockersSection } from '../components/sections/BlockersSection';
import { RealLifeSection } from '../components/sections/RealLifeSection';
import { IncludesSection } from '../components/sections/IncludesSection';
import { FitSection } from '../components/sections/FitSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { ReframeSection } from '../components/sections/ReframeSection';
import { EvaluationCta } from '../components/sections/EvaluationCta';
import { DiagnosisFormSection } from '../components/sections/DiagnosisFormSection';
import { FinalCta } from '../components/sections/FinalCta';
export function Landing() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white" data-id="element-334" data-mp="29s4s87z94sw">
      <Navbar data-id="element-335" data-mp="27ntv6bnv5j4" />
      <main data-id="element-336" data-mp="3tgbh5rtgp2tb">
        <Hero data-id="element-337" data-mp="3tfto1423j4pm" />
        <ProblemSection data-id="element-338" data-mp="3tg1xelz0frw2" />
        <TransformationSection data-id="element-339" data-mp="3tes1a2bpwts2" />
        <BlockersSection data-id="element-340" data-mp="3peq7sgg4z6nv" />
        <RealLifeSection data-id="element-341" data-mp="3pe85p36sly81" />
        <IncludesSection data-id="element-342" data-mp="3pfj6qv8usrvg" />
        <ResultsSection data-id="element-343" data-mp="3pguaww67o1n3" />
        <FitSection data-id="element-344" data-mp="3kfwscihah5l2" />
        <ReframeSection data-id="element-345" data-mp="3kgezia5hp47r" />
        <EvaluationCta data-id="element-346" data-mp="3kh7wijencfcp" />
        <DiagnosisFormSection data-id="element-347" data-mp="3khq42c6refzx" />
        <FinalCta data-id="element-348" data-mp="l11i6skvcdpr" />
      </main>
      <Footer data-id="element-349" data-mp="kz8arb2flpgp" />
    </div>;
}